import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Modal } from 'react-bootstrap';

import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';


import '../../mcss/common.css';
import * as Common from '../Common';

import '../../mcss/common.css';


import RequestHeader from './RequestHeader';

function DownloadSwift(props) {
    const navigate = useNavigate();

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);



    const [reqData, setReqData] = useState([]);

    const [docListData, setDocListData] = useState([]);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'SWIFTDOWNLOAD'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setReqData(resp1);
                        setDocListData(resp1.req_swiftinvoie);
                    });
                } else {
                    Common.callApi(Common.apiRight, [sid, 'all', 'INVOICEDOWNLOAD'], function (result) {
                        let resp2 = JSON.parse(result);
                        if (resp2.query === "1") {

                            Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                                let resp3 = JSON.parse(result1);
                                setReqData(resp3);
                                setDocListData(resp3.req_swiftinvoie);
                            });
                        } else {
                            navigate('/'); // no query right
                        }
                    });
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);


    function btnBackClick() {
        props.callInProgress();
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }
    const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };
    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>In Progress/Download</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <RequestHeader rhdata={reqData}></RequestHeader>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>

                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                        <td>Password</td>
                                        <td>Date</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.srno}>

                                            <td className='divHide'>{res.doc_srno}</td>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path : res.doc_filename}</td>
                                            <td>{res.cover_bank_pass}</td>
                                            <td>{(res.doc_uploadedat).split('-').reverse().join('/')}</td>
                                            {
                                                /*
                                                    <td>
                                                        <div className="colorThemeBlue">
                                                            <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>&nbsp;
                                                            <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                                <FontAwesomeIcon icon={faFileDownload} />
                                                            </span>
                                                        </div>
                                                    </td>
                                                */
                                            }

                                            <td>
                                                <div className="colorThemeBlue">
                                                    {
                                                        (res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                            || res.doc_ext === "jpg" || res.doc_ext === "png")) ?
                                                            <>
                                                                <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>&nbsp;
                                                            </> : null
                                                    }

                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span className="handCursor" onClick={(e) => Common.viewUploadedDocument(res.doc_aws_path, sid, openDocument)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        )}
                                                    &nbsp;&nbsp;
                                                    {res.doc_aws == 1 ? (

                                                        <span className="handCursor" onClick={(e) => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />
                                                        </span>
                                                    ) :
                                                        <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />
                                                        </span>
                                                    }

                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                </Container>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
     
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )

}
export default DownloadSwift;